import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { TestingTrailModel } from '../model/index';

@Injectable()
export class TestingTrailService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private testingTrailUrl = 'api/testingTrail';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getTestingList(query: any): Promise<TestingTrailModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.testingTrailUrl}/getTestingList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    updateTestingTrial(rowData: any): Promise<TestingTrailModel> {
        const url = `${this.testingTrailUrl}/updateTestingTrial`;

        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
            .catch(this.handleError);
    }
    updateServiceTesting(rowData: any): Promise<TestingTrailModel> {
        const url = `${this.testingTrailUrl}/updateServiceTesting`;

        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
            .catch(this.handleError);
    }
    updateGiveToServiceTesting(rowData: any): Promise<TestingTrailModel> {
        const url = `${this.testingTrailUrl}/updateGiveToServiceTesting`;

        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
            .catch(this.handleError);
    } 
    updateManufactureOut(rowData: any): Promise<TestingTrailModel> {
        const url = `${this.testingTrailUrl}/updateManufactureOut`;

        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
            .catch(this.handleError);
    }
    updateCourierDetails(rowData: any): Promise<TestingTrailModel> {
        const url = `${this.testingTrailUrl}/updateCourierDetails`;

        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
            .catch(this.handleError);
    }
    updateRecvCourierDetails(rowData: any): Promise<TestingTrailModel> {
        const url = `${this.testingTrailUrl}/updateRecvCourierDetails`;

        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as TestingTrailModel)
            .catch(this.handleError);
    }
    saveEmployeeApproval(pageData: any): Promise<any> {
        const url = `${this.testingTrailUrl}/saveEmployeeApproval`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }

    confirmTrialNotWilling(confirmData: any): Promise<any> {
        const url = `${this.testingTrailUrl}/confirmTrialNotWilling`;
        return this.http
            .post(url, $.param(confirmData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    markTrialNotWilling(trialData: any): Promise<any> {
        const url = `${this.testingTrailUrl}/markTrialNotWilling`;
        return this.http
            .post(url, $.param(trialData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    addPhoto(rowData: any): Promise<TestingTrailModel[]> {
        const url = `${this.testingTrailUrl}/addPhoto`; 
        var formData = new FormData();
        formData.append('files',rowData.files);
        formData.append('client_id',rowData.client_id);
           return this.http
            .post(url, formData)
            .toPromise()
            .then(res => res.json() as  Promise<TestingTrailModel[]>)
            .catch(this.handleError);      
    }



    getTrialDetailsByWalkinId(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({ headers: this.headers, search: params });
        const url = `${this.testingTrailUrl}/getTrialDetailsByWalkinId`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/testingTrail.service.ts